exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".batch-set .pointer[data-v-21a55d0d]{cursor:pointer}.batch-set .table .attr-img[data-v-21a55d0d]{width:40px;max-height:40px;-o-object-fit:contain;object-fit:contain}", ""]);

// exports
